"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var InputAction = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var icon = _ref.icon,
    tooltip = _ref.tooltip,
    onMouseDown = _ref.onMouseDown,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 16 : _ref$fontSize,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
    icon: icon,
    tooltip: tooltip,
    onMouseDown: onMouseDown,
    onClick: onClick,
    disabled: disabled,
    fontSize: fontSize,
    size: size,
    ref: ref
  });
});
var _default = exports["default"] = InputAction;